import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlarmClock, ArrowRight, ClipboardList } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export const DueSoonBanner = ({ summary, showLink = false }) => {
    if (!summary?.open) return null;
    const urgent = summary.due_soon > 0;
    const Icon = urgent ? AlarmClock : ClipboardList;
    return (
        <motion.div
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            className={`flex flex-wrap items-center gap-3 rounded-xl border px-4 py-3 ${urgent
                ? 'border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-800/60 dark:bg-amber-950/50 dark:text-amber-200'
                : 'border-border bg-muted/40'}`}
            data-testid="quality-due-soon-banner"
        >
            <Icon className={`h-5 w-5 shrink-0 ${urgent ? 'animate-pulse text-amber-600 dark:text-amber-400' : 'text-muted-foreground'}`} />
            <p className="flex-1 text-sm">
                {urgent
                    ? <><b>{summary.due_soon}</b> quality task{summary.due_soon > 1 ? 's are' : ' is'} due within 48 hours. Missed tasks score 0.</>
                    : <>You have <b>{summary.open}</b> open quality task{summary.open > 1 ? 's' : ''} from your Quality reviewer.</>}
            </p>
            {showLink && (
                <Link to="/quality-tasks" className="inline-flex items-center gap-1 text-sm font-medium text-violet-700 hover:underline dark:text-violet-300" data-testid="quality-banner-open-link">
                    Open Quality Tasks <ArrowRight className="h-4 w-4" />
                </Link>
            )}
        </motion.div>
    );
};

export const QualityTasksBanner = () => {
    const { api, user, isAdmin } = useAuth();
    const [summary, setSummary] = useState(null);
    const eligible = isAdmin || user?.feature_access?.staffing_training !== false;
    useEffect(() => {
        if (!eligible) return;
        api.get('/quality-tasks/my/summary').then(({ data }) => setSummary(data)).catch(() => {});
    }, [api, eligible]);
    return eligible ? <DueSoonBanner summary={summary} showLink /> : null;
};
